import React, { createContext, useState, useContext, useMemo } from 'react';
import api from '../store/api/api';
import ENDPOINTS from '../store/api/endpoints';

const EndPointsContext = createContext();

export const EndPointsProvider = ({ children }) => {


  // Expose API functions with endpoints
  const endpoints = useMemo(() => ({
    // Google Places endpoints using your existing api instance
    places: {
      autocomplete: async (input) => {
        try {
          // Using your existing api instance
          const response = await api.get(ENDPOINTS.PLACES_AUTOCOMPLETE, {
            params: { input }
          });
          return response.data;
        } catch (error) {
          console.error('[Endpoints] Autocomplete error:', error);
          throw error;
        }
      }, 
      details: async (placeId) => {
        try {
          const response = await api.get(ENDPOINTS.PLACES_DETAILS, {
            params: { placeId }
          });
          return response.data;
        } catch (error) {
          console.error('[Endpoints] Place details error:', error);
          throw error;
        }
      }
    },
  
  }), []);

  return (
    <EndPointsContext.Provider value={endpoints}>
      {children}
    </EndPointsContext.Provider>
  );
};

// Custom hook to use endpoints context
export const useEndPoints = () => {
  const context = useContext(EndPointsContext);
  if (!context) {
    throw new Error('useEndPoints must be used within an EndPointsProvider');
  }
  return context;
};

// Keep for backward compatibility
export const useAuth = useEndPoints; 